import React from 'react'

import { useSelectedIncidents } from '../hooks'
import { useAddIncidentFormIsOpen } from '../hooks'

import IncidentList from './IncidentList'
import IncidentDetailsPanel from './IncidentDetailsPanel'
import AddIncidentForm from './AddIncidentForm'

const PalmettoIncidentPanel = () => {
  const formIsOpen = useAddIncidentFormIsOpen()
  const [{ current }] = useSelectedIncidents()

  if (formIsOpen) return <AddIncidentForm />
  if (current) return <IncidentDetailsPanel />
  return <IncidentList />
}
export default PalmettoIncidentPanel
